import { z } from 'zod';
import { publicUserSchema } from './user.js';
/**
 * Csatorna-lista: pipalhato tetelek felelossel es hataridovel.
 *
 * ─── Miert nem eleg a canvas? ───────────────────────────────────────────────
 *
 * Egy canvasba is lehet listat irni, de az SZOVEG marad: nem lehet ranezesre
 * megmondani, mi van kesz, ki csinalja, es mi jar le holnap. A lista ezert
 * soronkent tarolja ezeket - igy a hatarido tenyleg datum, nem egy leirt szo,
 * a felelos pedig valodi felhasznalo, nem egy begepelt nev.
 *
 * A ketto egymas mellett el, ugyanabban a panelben: van, amit szoveggel jobb
 * elmondani, es van, amit ki kell pipalni.
 */
export const listItemSchema = z.object({
    id: z.string(),
    listId: z.string(),
    text: z.string(),
    isDone: z.boolean(),
    /** Kire van kiosztva. Ures is lehet: nem minden tetelnek van gazdaja. */
    assignee: publicUserSchema.nullable(),
    /** Nap pontossagu hatarido (`ÉÉÉÉ-HH-NN`), vagy semmi. */
    dueDate: z.string().nullable(),
    position: z.number(),
    completedBy: publicUserSchema.nullable(),
    completedAt: z.string().nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const listSchema = z.object({
    id: z.string(),
    channelId: z.string(),
    title: z.string(),
    description: z.string(),
    /**
     * A tetelek.
     *
     * Egyben jonnek a listaval, nem kulon lekerdezessel: egy lista tipikusan
     * nehany tucat sor, es kulon kerve minden megnyitas ket korbe kerulne.
     */
    items: z.array(listItemSchema),
    /** Osszefoglalo a panel listajahoz - nem kell hozza a teteleket vegignezni. */
    totalCount: z.number(),
    doneCount: z.number(),
    createdBy: publicUserSchema.nullable(),
    updatedBy: publicUserSchema.nullable(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/**
 * A cim felso hatara.
 *
 * Nem tartalmi korlat, hanem felulet-vedelem: a lista egy keskeny panelben
 * jelenik meg, es egy 2000 karakteres cim hasznalhatatlanna tenne.
 */
export const MAX_LIST_TITLE_LENGTH = 120;
export const MAX_LIST_DESCRIPTION_LENGTH = 400;
export const MAX_LIST_ITEM_LENGTH = 500;
/**
 * Ennyi tetel fer egy listaba.
 *
 * A tetelek egyben jonnek a listaval; korlat nelkul egy elszabadult lista
 * minden megnyitasnal megabajtokat mozgatna. Ezer sornal amugy is mas eszkoz
 * kell, nem egy csatorna melle akasztott lista.
 */
export const MAX_LIST_ITEMS = 1000;
export const listTitleSchema = z
    .string()
    .trim()
    .min(1, 'A cím nem lehet üres.')
    .max(MAX_LIST_TITLE_LENGTH, `A cím legfeljebb ${MAX_LIST_TITLE_LENGTH} karakter lehet.`);
/** Nap pontossagu datum. Idopont NEM: a "holnap" egy nap, nem egy masodperc. */
export const dueDateSchema = z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/, 'A határidő éééé-hh-nn alakú legyen.');
export const createListSchema = z.object({
    title: listTitleSchema,
    description: z.string().trim().max(MAX_LIST_DESCRIPTION_LENGTH).optional(),
});
export const updateListSchema = z.object({
    title: listTitleSchema.optional(),
    description: z.string().trim().max(MAX_LIST_DESCRIPTION_LENGTH).optional(),
});
export const createListItemSchema = z.object({
    text: z.string().trim().max(MAX_LIST_ITEM_LENGTH).optional(),
    assigneeId: z.string().nullable().optional(),
    dueDate: dueDateSchema.nullable().optional(),
    /** Ide kerul: a megadott tetel UTAN. Ures esetben a lista vegere. */
    afterItemId: z.string().nullable().optional(),
});
export const updateListItemSchema = z.object({
    text: z.string().max(MAX_LIST_ITEM_LENGTH).optional(),
    isDone: z.boolean().optional(),
    assigneeId: z.string().nullable().optional(),
    dueDate: dueDateSchema.nullable().optional(),
    /** Athelyezes: a megadott tetel UTAN. `null` = a lista elejere. */
    afterItemId: z.string().nullable().optional(),
});
/**
 * Lejart-e, vagy ma esedekes.
 *
 * A HELYI napot nezzuk, nem az UTC-t: aki este 11-kor nezi a listat, annak a
 * "ma" a sajat mai napja. Ezert nem `Date` osszehasonlitas van, hanem
 * szoveges - a `ÉÉÉÉ-HH-NN` alak epp azert jo, mert igy rendezheto.
 */
export function localDateKey(date) {
    const ev = date.getFullYear();
    const ho = String(date.getMonth() + 1).padStart(2, '0');
    const nap = String(date.getDate()).padStart(2, '0');
    return `${ev}-${ho}-${nap}`;
}
export function dueState(dueDate, now = new Date()) {
    if (!dueDate)
        return 'nincs';
    const ma = localDateKey(now);
    if (dueDate < ma)
        return 'lejart';
    return dueDate === ma ? 'ma' : 'kesobb';
}
//# sourceMappingURL=list.js.map